<div class="container" *ngIf="activity">
  <div class="row mt-5">
    <div class="col">
      <strong style="font-size: 26px">
        {{ activity.title }}
      </strong>
      <div class="d-flex justify-content-between">
        <div>
          <strong class="mr-3" *ngFor="
              let category of activity.categories.concat(
                activity.subCategories
              );
              let last = last
            ">
            {{ category.name }}<ng-container *ngIf="!last">,</ng-container>
          </strong>
          <span> | </span>
          <span class="vi-pin"></span>
          <span>
            {{ activity.location.name }},
            {{ activity.location.country || "ES" }}
          </span>
        </div>
        <div class="product-icons d-lg-block d-none">
          <!-- <span (click)="clickFavorite($event, activity['@id'])" [ngClass]="
              takerActivities.includes(activity['@id'])
                ? 'vi-heart-fill'
                : 'vi-heart'
            " class="mr-3 pointer"></span> -->
          <span (click)="shareActivity(activity)" class="vi-plane pointer"></span>
        </div>
      </div>
    </div>
  </div>
  <div class="rounded product-images row mt-4 mb-lg-5 w-100 mx-0">
    <div class="h-lg-100 col-md-6 col-sm-12 pl-0 position-relative">
      <img class="h-100 img-fluid" style="cursor: pointer"
        onError="this.src='https://app.venntur.com/assets/image-not-available-placeholder.png'" [src]="
          getUrl(
            activity['media'].length > 0 ? activity['media'][0].contentUrl : ''
          )
        " alt="Imagen de la empresa" (click)="openPhotosModal(photosContent, { class: 'photosModal' })" />
      <span *ngIf="activity.promotionType" class="position-absolute pink-button">{{ activity.promotionType }}</span>
    </div>
    <div class="w-100 d-block d-md-none">
      <div class="d-flex justify-content-between align-items-center" style="margin-top: 21px">
        <!-- Removed button here -->
        <div class="product-icons d-block d-lg-none">
          <!-- <span (click)="clickFavorite($event, activity['@id'])" [ngClass]="
              takerActivities.includes(activity['@id'])
                ? 'vi-heart-fill'
                : 'vi-heart'
            " class="mr-3 pointer"></span> -->
          <span (click)="shareActivity(activity)" class="vi-plane pointer"></span>
        </div>
      </div>
      <div class="select-anchor">
        <select class="w-100" name="select" (change)="
            scrollToElement($event.target.value.toString());
            activeTag = 'description'
          ">
          <option value="section-1">{{ "Descripción" | translate }}</option>
          <option value="section-2">{{ "Qué incluye" | translate }}</option>
          <option value="section-3">{{ "Excluido" | translate }}</option>
          <option value="section-4">{{ "Qué debes saber" | translate }}</option>
          <option value="section-5">
            {{ "Qué debes llevar" | translate }}
          </option>
        </select>
      </div>
    </div>
    <div class="col-md-6 d-md-block d-none pr-0">
      <div class="row m-0 w-100">
        <div class="col-md-6 pl-0" style="margin-bottom: 4px">
          <img class="img-fluid custom-image" style="cursor: pointer"
            onError="this.src='https://app.venntur.com/assets/image-not-available-placeholder.png'" [src]="
              getUrl(
                activity['media'].length > 1
                  ? activity['media'][1].contentUrl
                  : ''
              )
            " alt="Imagen de la experiencia" (click)="openPhotosModal(photosContent, { class: 'photosModal' })" />
        </div>
        <div class="col-md-6 pr-0">
          <img class="img-fluid custom-image" style="cursor: pointer"
            onError="this.src='https://app.venntur.com/assets/image-not-available-placeholder.png'" [src]="
              getUrl(
                activity['media'].length > 2
                  ? activity['media'][2].contentUrl
                  : ''
              )
            " alt="Imagen de la experiencia" style="border-radius: 0px 20px 0px 0px"
            (click)="openPhotosModal(photosContent, { class: 'photosModal' })" />
        </div>
        <div class="col-md-6 pl-0">
          <img class="img-fluid custom-image" style="cursor: pointer"
            onError="this.src='https://app.venntur.com/assets/image-not-available-placeholder.png'" [src]="
              getUrl(
                activity['media'].length > 3
                  ? activity['media'][3].contentUrl
                  : ''
              )
            " alt="Imagen de la experiencia" (click)="openPhotosModal(photosContent, { class: 'photosModal' })" />
        </div>
        <div class="col-md-6 pr-0">
          <img class="img-fluid custom-image" style="cursor: pointer"
            onError="this.src='https://app.venntur.com/assets/image-not-available-placeholder.png'" [src]="
              getUrl(
                activity['media'].length > 4
                  ? activity['media'][4].contentUrl
                  : ''
              )
            " alt="Imagen de la experiencia" style="border-radius: 0px 0px 20px 0px"
            (click)="openPhotosModal(photosContent, { class: 'photosModal' })" />
        </div>
      </div>
    </div>
  </div>

  <div class="row pt-md-0">
    <div class="col-lg-8 col-12 col pt-3 mb-5">
      <div class="product-details">
        <div class="product-anchors d-md-flex d-none">
          <a [ngClass]="{ active: activeTag == 'description' }"
            (click)="scrollToElement('section-1'); activeTag = 'description'"><strong>{{ "Descripción" | translate
              }}</strong></a>
          <a *ngIf="activity.includes && activity.includes.length > 0" [ngClass]="{ active: activeTag == 'includes' }"
            (click)="scrollToElement('section-2'); activeTag = 'includes'"><strong>{{ "Qué incluye" | translate
              }}</strong></a>
          <a *ngIf="activity.notIncludes && activity.notIncludes.length > 0"
            [ngClass]="{ active: activeTag == 'not-includes' }"
            (click)="scrollToElement('section-3'); activeTag = 'not-includes'"><strong>{{ "Excluido" | translate
              }}</strong></a>
          <a *ngIf="activity.importantInformation" [ngClass]="{ active: activeTag == 'what-to-know' }"
            (click)="scrollToElement('section-4'); activeTag = 'what-to-know'"><strong>{{ "Qué debes saber" | translate
              }}</strong></a>
          <a *ngIf="activity.carry" [ngClass]="{ active: activeTag == 'what-to-bring' }"
            (click)="scrollToElement('section-5'); activeTag = 'what-to-bring'"><strong>{{ "Qué debes llevar" |
              translate }}</strong></a>
        </div>
        <div class="d-flex rounded p-3 product-details">
          <div class="pr-3">
            <span class="vi-clock pr-1"></span>
            <span>
              {{ convertTimeToCustomFormat(activity.duration) }}
            </span>
            <!-- <span *ngIf="activity.duration == null">
                            Sin datos
                        </span> -->
          </div>
          <div>
            <span class="pr-2 d-none d-md-inline">|</span>
            <span class="vi-bubble pr-1"></span>
            <span *ngFor="let language of activity.languages; let last = last">
              {{ language }}<ng-container *ngIf="!last">,</ng-container>
            </span>
            <span *ngIf="activity.languages.length == 0"> Sin datos </span>
          </div>
        </div>
        <div id="section-1" class="includes">
          <span [innerHTML]="activity.extendedDescription"></span>
          <span *ngIf="activity.description == ''"> Sin datos </span>
        </div>
        <div class="row m-0 p-0">
          <div class="col-lg-6 col pl-0" *ngIf="activity.includes && activity.includes.length != 0">
            <div id="section-2" class="title">
              <span>
                {{ "Qué incluye" | translate }}
              </span>
            </div>
            <ng-container *ngIf="activity.includes && activity.includes !== ''">
              <span [innerHTML]="activity.includes"></span>
            </ng-container>
          </div>
          <div class="col-lg-6 col-12 pl-0 pl-lg-3 pr-0"
            *ngIf="activity.notIncludes && activity.notIncludes.length != 0">
            <div id="section-3" class="title">
              <span>
                {{ "Excluido" | translate }}
              </span>
            </div>
            <ng-container *ngIf="activity.notIncludes && activity.notIncludes !== ''">
              <span [innerHTML]="activity.notIncludes"></span>
            </ng-container>
          </div>
        </div>
        <div id="section-4" class="py-4" *ngIf="activity.importantInformation">
          <div class="title">
            <span>
              {{ "Qué debes saber" | translate }}
            </span>
          </div>
          <span [innerHTML]="activity.importantInformation"> </span>
          <span *ngIf="activity.importantInformation === ''"> Sin datos </span>
        </div>
        <div id="section-5" class="py-4" *ngIf="activity.carry">
          <div class="title">
            <span>
              {{ "Qué debes llevar" | translate }}
            </span>
          </div>
          <span [innerHTML]="activity.carry"></span>
        </div>
        <!-- <div id="TA_cdsratingsonlywide815" class="TA_cdsratingsonlywide"><ul id="FMiDr6" class="TA_links p92BQ7"><li id="EqNTmOQ" class="BupNoTTHS"><a target="_blank" href="https://www.tripadvisor.com/Attraction_Review-g187471-d19512935-Reviews-Camello_Safari_Duna_Oasis-Gran_Canaria_Canary_Islands.html"><img src="https://www.tripadvisor.com/img/cdsi/img2/branding/v2/Tripadvisor_lockup_horizontal_secondary_registered-18034-2.svg" alt="TripAdvisor"/></a></li></ul></div>                <div *ngIf="false" id="section-6" class="py-4 tripadvisor-widget" style="min-height: 680px;">
                    <div class="d-flex justify-content-between mb-3">
                        <div class="d-flex flex-column">
                            <div class="d-flex mb-2">
                                <img class="mr-2" src="../../../../assets/images/tripadvisor.jpg"
                                    alt="Logo TripAdvisor">
                                <span style="font-size: 20px;">Rating</span>
                            </div>
                            <div class="d-flex align-items-center">
                                <span class="mr-2">3.0</span>
                                <div *ngFor="let ball of [].constructor(3)">
                                    <span class="ball"></span>
                                </div>
                                <div *ngFor="let emptyBall of [].constructor(2)">
                                    <span class="empty-ball"></span>
                                </div>
                                <span class="ml-2" style="font-size: 12px;">102 reviews</span>
                            </div>
                        </div>
                        <div>
                            <button class="tripadvisor-button">{{'Deja tu reseña' | translate}}</button>
                        </div>
                    </div>
                    <div *ngFor="let opinion of tripAdvisorOpinions" class="d-flex my-3">
                        <img class="userImage mr-3" [src]="opinion.image" alt="Imagen de la reseña">
                        <div>
                            <div class="d-flex flex-column mb-3">
                                <strong style="font-size: 14px;">
                                    {{opinion.username}}
                                </strong>
                                <span style="font-size: 12px;">
                                    {{opinion.date}}
                                </span>
                            </div>
                            <div class="d-flex flex-column">
                                <strong>
                                    {{opinion.title}}
                                </strong>
                                <span>
                                    {{opinion.review}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div> -->
        <app-review-form (formSent)="loadActivity()" [receivedData]="activity['@id']"></app-review-form>
        <app-reviews [receivedData]="reviews"></app-reviews>
      </div>
    </div>
    <div class="col-lg-4 col-12 pt-lg-0 pt-4 mb-5">
      <div class="booking-widget text-center">
        <div>
          <strong>
            {{ "Solicitud de Reserva" | translate }}
          </strong>
        </div>
        <!-- <ng-container *ngIf="showDefault"> -->
        <ng-container *ngIf="showDefault">
          <booking-widget [lang]="currentLang" api_url="https://api.venntur.hub2b.travel" web_city="Barcelona"
            [productid]="activity.id" [channelactivitycode]="activity.id" external_channel="venntur"
            PUBLIC_KEY="pk_live_oJ6GN2TgQ5d6LvUiigRMQU6L003eXQBbMH" producttype="Activity">
          </booking-widget>
        </ng-container>
        <ng-container *ngIf="!showDefault">
          <div class="card shadow rounded p-3" style="min-height: 680px; margin-bottom: 50px">
            <div class="d-flex flex-column justify-content-center">
              <div *ngIf="turitopId" id="turitop-calendar" class="load-turitop mb-5" [attr.data-service]="turitopId"
                data-lang="es" data-embed="box"></div>
              <div id="fareharbor-calendar" class="fareharbor-calendar-wrap"></div>
              <div *ngIf="bokunId" class="bokunWidget" [attr.data-src]="
                  'https://widgets.bokun.io/online-sales/' +
                  (this.activity.bookingEngineWidget
                    ? this.activity.bookingEngineWidget
                    : this.activity.supplier.bookingEngineWidget) +
                  '/activity-calendar/' +
                  bokunId +
                  '?isDuda=true&lang=es'
                "></div>
              <iframe *ngIf="rezdyId" seamless="" width="auto" height="1000px" frameborder="0" class="rezdy" src=""
                id="iFrameResizer0" scrolling="no" style="overflow: hidden; height: 828.438px"></iframe>
              <template *ngIf="donicusId" [id]="'don-' + this.activity.bookingEngineWidget"></template>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- <button [routerLink]="'/' + translate.getDefaultLang() + '/experiencias/' + activity.slug + '/redirigir'" target="_blank" class="btn btn-primary w-100 mb-3" [disabled]="bookingRequestSuccess">{{ 'Reservar en la web' | translate }}</button> -->

      <!-- <div class="d-flex flex-column text-center mb-3">
                <div class="p-0" style="font-size: 18px;">
                    <strong>
                        {{ '¿Alguna duda?' | translate }}
                    </strong>
                </div>
                <small>
                    {{ 'Estamos aquí para ayudarte' | translate }}
                </small>
            </div> -->
      <div class="maker-info card rounded">
        <div class="d-flex justify-content-between">
          <span>{{ "Organizado por" | translate }}</span>
          <a *ngIf="
              activity['supplier']['subscriptionPlan'] &&
              activity['supplier']['subscriptionPlan']['plan']['shortName'] !==
                'Free'
            " [routerLink]="
              '/' +
              translate.getDefaultLang() +
              '/maker/' +
              activity.supplier.slug
            ">
            {{ "Ver ficha de empresa" | translate }}
          </a>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <a [routerLink]="
              '/' +
              translate.getDefaultLang() +
              '/maker/' +
              activity['supplier']['slug']
            ">
            <img class="pl-1" alt="Logo de la empresa" [src]="
                apiUrl +
                (activity['supplier'] &&
                activity['supplier']['media'] &&
                activity['supplier']['media'].length > 0
                  ? activity['supplier']['media'][0].contentUrl
                  : '')
              " height="40" />
          </a>
          <a [routerLink]="
              '/' +
              translate.getDefaultLang() +
              '/maker/' +
              activity.supplier.slug
            " class="text-dark font-weight-bold">
            <span>{{ activity.supplier.name }}</span>
          </a>
        </div>
        <div class="maker-info-footer d-flex justify-content-between m-0 w-100">
          <a [href]="activity.supplier.web" target="_blank" class="w-100 h-100">
            <span class="vi-web"></span>
          </a>
          <ng-template #tol1Template>{{ customPhoneTooltip }}</ng-template>
          <span class="d-none d-lg-flex w-100 h-100 pointer" [tooltip]="tol1Template"
            (click)="changePhoneTooltip(activity.supplier.phone)">
            <span class="vi-mobile"></span>
          </span>
          <a [href]="'tel:' + activity.supplier.phone" class="d-flex d-lg-none w-100 h-100">
            <span class="vi-mobile"></span>
          </a>

          <ng-template #tol2Template>{{ customEmailTooltip }}</ng-template>
          <span class="d-none d-lg-flex w-100 h-100 pointer" [tooltip]="tol2Template"
            (click)="changeEmailTooltip(activity.supplier.email)">
            <span class="vi-email"></span>
          </span>
          <a [href]="
              'mailto:' + activity.supplier.email + '?Subject=Hola%20Maker'
            " class="d-flex d-lg-none w-100 h-100">
            <span class="vi-email"></span>
          </a>

          <a *ngIf="activity.supplier.whatsapp" [href]="'https://wa.me/' + activity.supplier.whatsapp"
            class="pointer d-none d-lg-flex w-100 h-100">
            <span class="vi-whatsapp"></span>
          </a>
          <a *ngIf="activity.supplier.whatsapp" [href]="
              'whatsapp://send?phone=' +
              activity.supplier.whatsapp.replace('+', '')
            " class="d-flex d-lg-none w-100 h-100">
            <span class="vi-whatsapp"></span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #photosContent>
  <div class="modal-body mx-auto d-flex flex-column">
    <carousel [isAnimated]="true" [interval]="false" [showIndicators]="false">
      <div *ngFor="let mediaActivity of activity.media; let i = index">
        <slide>
          <div class="d-flex justify-content-between modal-body-actions my-3">
            <span class="mr-4">{{ i + 1 }}/{{ activity.media.length }}</span>
            <div class="activity-icons">
              <!-- <span (click)="clickFavorite($event, activity['@id'])" [ngClass]="
                  takerActivities.includes(activity['@id'])
                    ? 'vi-heart-fill'
                    : 'vi-heart'
                " class="vi-heart mr-3 pointer"></span> -->
              <span (click)="shareActivity(activity)" class="vi-plane mr-3 pointer"></span>
            </div>
            <button type="button" class="btn btn-lg btn-white btn-close pull-right ml-auto p-1" aria-label="Close"
              (click)="modalRef.hide()">
              <span class="vi-close"></span>
            </button>
          </div>
          <img [src]="getUrl(mediaActivity.contentUrl)" class="rounded" style="display: block; width: 100%"
            onError="this.src='assets/image-not-available-placeholder.png'" />
        </slide>
      </div>
    </carousel>
  </div>
</ng-template>

<div *ngIf="isAlertShown" [config]="{ show: true }" (onHidden)="onHidden()" bsModal #autoShownModal="bs-modal"
  class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-auto-name">
  <div class="modal-dialog">
    <div class="modal-content">
      <button type="button" class="btn btn-sm btn-light btn-close pull-right ml-auto" aria-label="Close"
        (click)="hideModal()">
        <span class="vi-close"></span>
      </button>
      <div class="modal-body text-center">
        <p><span class="vi-info text-primary h3"></span></p>
        <p [innerHTML]="'RegFavs' | translate"></p>
        <app-login></app-login>
      </div>
    </div>
  </div>
</div>